import React from 'react';
import {
  AuthFormLayout,
  AuthFormLayoutProps,
} from '../../../../../../Components/Forms/Auth';
import { Alert, Box } from '@mui/material';
import GeneralSection from '../../Sections/GeneralSection/GeneralSection';
import { AdditionalSection } from '../../Sections/AdditionalSection/AdditionalSection';

type Props<T> = AuthFormLayoutProps<T> & React.PropsWithChildren;

export const FormView = <T,>(restProps: Props<T>) => {
  return (
    <AuthFormLayout<T> {...restProps}>
      <Box
        sx={{
          padding: '10px 15px',
        }}
      >
        <Alert
          variant="standard"
          severity="info"
          sx={{
            fontSize: '7.1pt',
          }}
        >
          An email with instructions will be sent to your email address.
        </Alert>
      </Box>
      <GeneralSection />
      <AdditionalSection />
    </AuthFormLayout>
  );
};
